import React from 'react';
import MediaQuery from 'react-responsive';

const breakpoints = {
  desktop: '(min-width: 768px)',
  tablet: '(min-width: 576px) and (max-width: 767px)',
  mobile: '(max-width: 575px)',
  tabletMobile: '(max-width: 767px)',
  desktopTablet: '(min-width: 576px)',
};

interface IProps {
  name: 'desktopTablet' | 'desktop' | 'mobile' | 'tablet' | 'tabletMobile';
}

export const Breakpoint = (props: React.PropsWithChildren<IProps>): JSX.Element => {
  const breakpoint = breakpoints[props.name] || breakpoints.desktop;
  return (
    <MediaQuery query={breakpoint}>
      <>{props.children}</>
    </MediaQuery>
  );
};
